import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
import zh_HK from '@angular/common/locales/zh-Hans-HK';
import en from '@angular/common/locales/en';  
import ar from '@angular/common/locales/ar';
import fr from '@angular/common/locales/fr';

registerLocaleData(zh, 'zh-CN');
registerLocaleData(zh_HK, 'zh-TW');
registerLocaleData(en, 'en-US');
registerLocaleData(ar , 'ar');
registerLocaleData(fr, 'fr-FR');
registerLocaleData(fr, 'fr');



if (environment.production) {
  enableProdMode();
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
